export default async function themeComponent(theme, componentName) {
  const importAliases = await loadImportAliases(theme)

  const componentNameTarget = importAliases[componentName] || componentName

  let parentTheme = theme
  const parents = [...theme.inheritanceChain, { slug: 'default' }]

  while (parentTheme) {
    try {
      const sfc = await import(`./${parentTheme.slug}/${componentNameTarget}.vue`)

      return {
        component: sfc.default,
        group: sfc.group || null,
        reuseComponent: sfc.reuseComponent || false,
      }
    } catch {
      parentTheme = parents.shift()
      if (!parentTheme) {
        throw new Error(`Component ${componentNameTarget} ${importAliases[componentName] ? '(alias)' : ''} not found in theme ${theme.slug} or its parents.`)
      }
    }
  }
}

export async function themeGroupComponent(theme, componentName) {
  let parentTheme = theme
  const parents = [...theme.inheritanceChain, { slug: 'default' }]

  while (parentTheme) {
    try {
      const sfc = await import(`./${parentTheme.slug}/groups/${componentName}.vue`)

      return {
        component: sfc.default,
        groupId: sfc.groupId || null,
      }
    } catch {
      parentTheme = parents.shift()
      if (!parentTheme) {
        throw new Error(`Component ${componentName} not found in theme ${theme.slug} or its parents.`)
      }
    }
  }
}

const importAliasCache = new Map()

async function loadImportAliases(theme) {
  if (importAliasCache.has(theme)) {
    return importAliasCache.get(theme)
  }

  let parentTheme = theme
  const parents = [...theme.inheritanceChain, { slug: 'default' }]

  let aliases = {}

  while (parentTheme) {
    try {
      const importedAliases = await import(`./${parentTheme.slug}/importAliases.js`)
      aliases = { ...aliases, ...importedAliases.default }
    } catch {
      // Ignore errors and continue with the next parent theme
    } finally {
      parentTheme = parents.shift()
    }
  }

  importAliasCache.set(theme, aliases)

  return aliases
}
